var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["c-available-now", _vm.className] }, [
    _c("div", { staticClass: "o-width-limiter o-width-limiter--main" }, [
      _c("div", { staticClass: "c-available-now__wrapper" }, [
        _c("div", { staticClass: "c-available-now__content" }, [
          _c(
            "h2",
            { staticClass: "c-available-now__heading heading-boarder" },
            [_vm._v(_vm._s(_vm.heading))]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "c-available-now__list" },
            [_vm._t("default")],
            2
          )
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "c-available-now__roof",
          attrs: {
            src: "/gui/images/roof-blue.svg",
            alt: "",
            "aria-hidden": "true"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }